// extracted by mini-css-extract-plugin
export default {"login_button":"Header_login_button__CcemW","auth_icon":"Header_auth_icon__+txoe"};